var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.5,
    height: 35.5,
    viewBox: "0 0 35.5 35.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfeef7;}.b{fill:none;stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-891.25 -791.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M286.982,273.86h-3.419V271.3l-7.693,5.128,7.693,5.128v-2.564h3.419a4.286,4.286,0,0,1,4.274,4.274c0,2.351-1.994,3.7-4.274,4.274a12.588,12.588,0,0,0-1.58.4,2.643,2.643,0,0,0-1.174.844,2.212,2.212,0,0,0-.3,1.969,2.81,2.81,0,0,0,1.889,1.755,7.187,7.187,0,0,0,4.807-.56,9.86,9.86,0,0,0,3.673-2.793l.056-.07a9.389,9.389,0,0,0-7.373-15.219Z",
    transform: "translate(629.616 531.199)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(892 792)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M254.966,260v6.838H243V260",
    transform: "translate(-231.983 -260)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 4.734,
    transform: "translate(4.734 30.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M264,273.6V260H230v34h24.65a9.377,9.377,0,0,0,9.35-9.35h0a9.377,9.377,0,0,0-9.35-9.35h-3.4v-2.55l-7.65,5.1,7.65,5.1V280.4h3.4a4.263,4.263,0,0,1,4.25,4.25h0a4.262,4.262,0,0,1-4.25,4.25H250.4",
    transform: "translate(-230 -260)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.e88e6de55347a2f57e20fe580e68b174.svg";
export { ForwardRef as ReactComponent };